import { useOktaAuth } from "@okta/okta-react";
import LeaveIcon from "@8x8/oxygen-icon/icons/LeaveIcon";
import { notify, TYPE } from "@8x8/oxygen-toaster";
import { MenuItem } from "@8x8/oxygen-sidebar-menu";
import React from "react";

export const LogoutButton = () => {
  const { oktaAuth } = useOktaAuth();
  const handleLogout = () => oktaAuth.signOut();
  return (
    <MenuItem
      label="Logout"
      icon={<LeaveIcon />}
      onTrigger={() =>
        notify({
          content: "Are you sure you want to logout?",
          actions: [{ title: "Yes", callback: handleLogout }],
          type: TYPE.warning,
          duration: 3000,
        })
      }
    />
  );
};
